// Importing validation libraries from Yup
import {
  mixed, object, string, date, number,
} from "yup";

// Regular expressions for validation
const phoneNumberRegEx = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/; // Regex for phone number validation
const emailRegEx = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // Regex for email validation

// Exporting validation schemas
export default {
  // Validation schema for user login
  loginUser: object({
    id: string("Please enter a valid Email.")
      .required("Email is required.")
      .test(
        "id",
        "Please enter a valid Email.",
        value => !value
          || emailRegEx.test(value)
          || /^(\+\d{1,3}[- ]?)?\d{10}$/.test(parseInt(value))
      )
      .trim(),
    password: string("Please enter a valid password.")
      .required("Password is required")
      .trim(),
  }),

  // Validation schema for admin login
  loginAdmin: object({
    clientId: string("Please enter a valid client id.")
      .required("Client Id is required.")
      .trim(),
    id: string("Please enter a valid Email.")
      .required("Email is required.")
      .test(
        "id",
        "Please enter a valid Email.",
        value => !value
          || emailRegEx.test(value)
          || /^(\+\d{1,3}[- ]?)?\d{10}$/.test(parseInt(value))
      )
      .trim(),
    password: string("Please enter a valid password.")
      .required("Password is required")
      .trim(),
  }),

  // Validation schema for resetting password
  resetPassword: object({
    password: string("Please enter a valid password.")
      .required("Password is required")
      .trim()
      .test(
        "password",
        "Password length must be minimum 8 characters.",
        value => !value || value.length >= 8
      )
      .test(
        "password",
        "Password length cannot be more than 20 characters.",
        value => !value || value.length <= 20
      )
      .test("password", "At least 1 lowercase letter required.", value => !value || value.toUpperCase() !== value)
      .test("password", "At least 1 uppercase letter required.", value => !value || value.toLowerCase() !== value)
      .test("password", "At least 1 digit is required.", value => !value || /\d/.test(value))
      .test(
        "password",
        "At least 1 special character is required.",
        value => !value || !/^[A-Za-z0-9 ]+$/.test(value)
      ),
    confirmPassword: string("Please enter a valid password.")
      .required("Password is required")
      .test(
        "confirmPassword",
        "Password and Confirm Password do not match.",
        function (value) {
          return this.parent.password === value;
        }
      )
      .trim(),
  }),

  // Validation schema for adding/editing groups
  addEditGroups: object({
    groupName: string("Please enter a valid group name.")
      .required("Group name is required.")
      .trim(),
    groupType: string("Please select a group type.").nullable().trim(),

    groupStatus: string("Please select a group status.")
      .required("Legal name is required.")
      .trim(),
  }),

  // Validation schema for merchant sign-up
  merchantSignUp: object({
    First_Name: string("Please enter a valid first name.")
      .required("First name is required.")
      .trim(),
    Last_Name: string("Please enter a valid last name.")
      .required("Last name is required.")
      .trim(),
    Email: string("Please enter a valid email address.")
      .required("Email is required.")
      .email("Please enter a valid email address.")
      .test(
        "Email",
        "Please enter a valid email address.",
        value => !value || emailRegEx.test(value)
      )
      .trim(),
    legalName: string("Please enter a valid email address.").trim(),
    dbaName: string("Please enter a valid email address.").trim(),
  }),

  makePaymentPage: object({
    First_Name: string("Please enter a valid first name.")
      .required("First name is required.")
      .trim(),
    Last_Name: string("Please enter a valid last name.")
      .required("Last name is required.")
      .trim(),
    Email: string("Please enter a valid email address.")
      .required("Email is required.")
      .email("Please enter a valid email address.")
      .test(
        "Email",
        "Please enter a valid email address.",
        value => !value || emailRegEx.test(value)
      )
      .trim(),
    // accountNumber:validationSchema,
    // confirmAccountNumber: validationSchema
    // address_one: string("Please enter a valid address.").required("Address is required.").trim(),
    // address_tow: string("Please enter a valid address.").required("Address is required.").trim()
  }),

  createUser: object({
    First_Name: string("Please enter a valid first name.")
      .required("First name is required.")
      .trim(),
    Middle_Name: string("Please enter a valid first name.").nullable().trim(),
    Last_Name: string("Please enter a valid last name.")
      .required("Last name is required.")
      .trim(),
    Email: string("Please enter a valid email address.")
      .required("Email is required.")
      .email("Please enter a valid email address.")
      .test(
        "email",
        "Please enter a valid email address.",
        value => !value || emailRegEx.test(value)
      )
      .trim(),
    Profile_Code: string("Please select a valid Profile Code")
      .required("Profile Code is required.")
      .trim(),
    Address1: string("Please enter a valid address 1")
      .required("Address 1 is required.")
      .trim(),
    Address2: string("Please enter a valid address 2").nullable().trim(),
    Country_Code: string("Please select a valid country")
      .required("Country is required.")
      .trim(),
    State_Code: string("Please enter a valid state")
      .required("State is required.")
      .trim(),
    City: string("Please enter a valid city")
      .required("City is required.")
      .trim(),
    Zip: mixed()
      .test(
        "zip",
        "Please enter a valid zip",
        value => !value
          || (!value.toString().includes("-")
            && !value.toString().includes("+")
            && value.toString().length === 5)
      )
      .required("Zip is required."),
    Mobile: mixed()
      .test(
        "mobile",
        "Please enter a valid mobile number.",
        value => !value || (phoneNumberRegEx.test(value) && value.length === 12)
      )
      .required("Mobile number is required."),
    Phone_No: mixed()
      .nullable()
      .test(
        "mobile",
        "Please enter a valid mobile number.",
        value => !value || (phoneNumberRegEx.test(value) && value.length === 12)
      ),
    Time_Zone_Code: string().required("Time Zone is required."),
    reportsTo: string().required("Reports To is required."),
    Password: string("Please enter a valid password.")
      .required("Password is required")
      .trim()
      .test(
        "Password",
        "Password length must be minimum 8 characters.",
        value => !value || value.length >= 8
      )
      .test(
        "Password",
        "Password length cannot be more than 20 characters.",
        value => !value || value.length <= 20
      )
      .test("Password", "At least 1 lowercase letter required.", value => !value || value.toUpperCase() !== value)
      .test("Password", "At least 1 uppercase letter required.", value => !value || value.toLowerCase() !== value)
      .test("Password", "At least 1 digit is required.", value => !value || /\d/.test(value))
      .test(
        "Password",
        "At least 1 special character is required.",
        value => !value || !/^[A-Za-z0-9 ]+$/.test(value)
      ),
    confirmPassword: string("Please enter a valid password.")
      .required("Confirm Password is required")
      .test(
        "confirmPassword",
        "Password and Confirm Password does not match.",
        function (value) {
          return this.parent.Password === value;
        }
      )
      .trim(),
    profileVisibility: string()
      .required(
        "Profile Visibility is a required field. Please select a option."
      )
      .trim(),

    repoCode: string().test(
      "repoCode",
      "Please enter a valid user code.",
      value => !value || /^[a-zA-Z0-9/-]+$/.test(value)
    ).required("Rep Code is required.").min(3)
      .max(12)
      .trim(),
    Role_ID: string().required("Please select a Role.").trim(),
    Notes: string("Please write a note for user.").nullable().trim(),
  }),
  updateUser: object({
    First_Name: string("Please enter a valid first name.")
      .required("First name is required.")
      .trim(),
    Middle_Name: string("Please enter a valid first name.").nullable().trim(),
    Last_Name: string("Please enter a valid last name.")
      .required("Last name is required.")
      .trim(),
    Email: string("Please enter a valid email address.")
      .required("Email is required.")
      .email("Please enter a valid email address.")
      .test(
        "email",
        "Please enter a valid email address.",
        value => !value || emailRegEx.test(value)
      )
      .trim(),
    Profile_Code: string("Please select a valid Profile Code")
      .required("Profile Code is required.")
      .trim(),
    Address1: string("Please enter a valid address 1")
      .required("Address 1 is required.")
      .trim(),
    Address2: string("Please enter a valid address 2").nullable().trim(),
    Country_Code: string("Please select a valid country")
      .required("Country is required.")
      .trim(),
    State_Code: string("Please enter a valid state")
      .required("State is required.")
      .trim(),
    City: string("Please enter a valid city")
      .required("City is required.")
      .trim(),
    Zip: mixed()
      .test(
        "zip",
        "Please enter a valid zip",
        value => !value
          || (!value.toString().includes("-")
            && !value.toString().includes("+")
            && value.toString().length === 5)
      )
      .required("Zip is required."),
    Mobile: mixed()
      .test(
        "mobile",
        "Please enter a valid mobile number.",
        value => !value || (phoneNumberRegEx.test(value) && value.length === 12)
      )
      .required("Mobile number is required."),
    Phone_No: mixed()
      .nullable()
      .test(
        "mobile",
        "Please enter a valid mobile number.",
        value => !value || (phoneNumberRegEx.test(value) && value.length === 12)
      ),
    Time_Zone_Code: string().required("Time Zone is required."),
    reportsTo: string().required("Reports To is required."),
    Password: string("Please enter a valid password.")
      .trim()
      .test(
        "Password",
        "Password length must me be minimum 8 characters.",
        value => !value || value.length >= 8
      )
      .test(
        "Password",
        "Password length cannot be more than 20 characters.",
        value => !value || value.length <= 20
      )
      .test("Password", "At least 1 lowercase letter required.", value => !value || value.toUpperCase() !== value)
      .test("Password", "At least 1 uppercase letter required.", value => !value || value.toLowerCase() !== value)
      .test("Password", "At least 1 digit is required.", value => !value || /\d/.test(value))
      .test(
        "Password",
        "At least 1 special character is required.",
        value => !value || !/^[A-Za-z0-9 ]+$/.test(value)
      ),
    confirmPassword: string("Please enter a valid password.")
      .test(
        "confirmPassword",
        "Password and Confirm Password does not match.",
        function (value) {
          return this.parent.Password === value;
        }
      )
      .trim(),
    profileVisibility: string()
      .required(
        "Profile Visibility is a required field. Please select a option."
      )
      .trim(),
    Role_ID: string().required("Please select a Role.").trim(),
  }),

  kycSubQues: object({
    idNumber: string("Please enter a valid Id number.")
      .required("Id number is required.")
      .trim(),
    issueDate: date("plassdasd").required("Issued Date is required."),
    dateExpires: date("asdasdasd").required("Date of Expire is required."),
    country: string("Please select a valid country")
      .required("Country is required.")
      .trim(),
    state: string("Please enter a valid state")
      .required("State is required.")
      .trim(),
    city: string("Please enter a valid city")
      .required("City is required.")
      .trim(),
  }),
  pricingTemplateAddEdit: object({
    name: string("Please enter a valid template name.")
      .required("Pricing template name is required.")
      .trim(),
    processorId: string("Please select a valid processor")
      .required("Processor is required.")
      .trim(),
    applicationId: string("Please select a valid application")
      .required("Application is required.")
      .trim(),
    startDate: date("Please select a valid date").required(
      "Start Date is required."
    ),
    termLengthDays: number("Term days must be a number.")
      .required("Terms days is required.")
      .test("Password", "Invalid term days value.", value => /^[1-9]\d*$/.test(value)),
    status: string("Status value is invalid").trim(),
    Notes: string("Please enter valid notes").nullable().trim(),
  }),
  addNotes: object({
    type: string("Please select type.").required("Type is required.").trim(),
    description: string("please write description.")
      .required("Description is required.")
      .trim()
      .max(2000, "Reached maximum allowed characters"),
  }),
};
